import { useRef, useState } from 'react';
import { apiSubmitAgreementPassword } from 'api/mall';
const ResourceLock = ({ passwordInfo, refresh }) => {
  const [errorInfo, setErrorInfo] = useState('');
  const password = useRef('');
  const handleSubmit = async () => {
    try {
      if (!password.current.trim()) {
        setErrorInfo('请输入访问密码');
        return;
      }
      const params = {
        subjectId: passwordInfo.sysNo,
        password: password.current.trim(),
      };
      await apiSubmitAgreementPassword({ json: params });
      setErrorInfo('');
      refresh();
    } catch (error) {
      if (error.code === 400107 || error.code === 400108) {
        setErrorInfo(error.message);
      }
    }
  };
  const handleInput = (e) => {
    var val = e.target.value || '';
    if (val) {
      password.current = val;
      setErrorInfo('');
    }
  };
  return (
    <div id="resource-lock-wrap" className="resource">
      <div className="content">
        <p className="name">《{passwordInfo?.agreementName}》</p>
        <div className="pwd-input">
          <i className="iconfont icon-lock1" />
          <input
            className={errorInfo && 'is-error'}
            type="password"
            maxLength={6}
            placeholder="请输入访问密码"
            onInput={handleInput}
          />
        </div>
        <p className="error">{errorInfo}</p>
        <div className="pwd-btn" onClick={handleSubmit}>
          确定
        </div>
        <p className="info">
          <i className="iconfont icon-icon_warn" />
          如需帮助，请联系交易规则创建人
          {passwordInfo?.inUserName}({passwordInfo?.inUserPhone})
        </p>
      </div>
      <style jsx>{`
        #resource-lock-wrap {
            text-align: center;
            padding-top: 45px;
          }
          #resource-lock-wrap .content{
            display: inline-block;
            vertical-align: top;
            width: 400px;
            height: auto;
          }
          #resource-lock-wrap .name{
            font-size: 18px;
            color: #333333;
            text-align: center;
            line-height: 26px;
            font-weight: 500;
          }
          #resource-lock-wrap .pwd-input{
            margin-top: 35px;
            position: relative;
          }
          #resource-lock-wrap .pwd-input > .mallfont{
            position: absolute;
            font-size: 16px;
            left: 13px;
            top: 9px;
            color: #999999;
          }
          #resource-lock-wrap .pwd-input input{
            outline: none;
            width: 100%;
            height: 42px;
            padding: 12px 38px;
            font-size: 14px;
            text-align: left;
            border: 1px solid #D6D6D6;
            border-radius: 3px;
            color: #333333;
            letter-spacing: 4px;
          }
          #resource-lock-wrap .pwd-input input.is-error{
            border-color: #fe3351;
          }
          #resource-lock-wrap .pwd-btn{
            width: 100%;
            height: 42px;
            line-height: 42px;
            text-align: center;
            margin-top: 10px;
            font-size: 16px;
            outline: none;
            border: none;
            border-radius: 3px;
            font-weight: normal;
            background-color: var(--rv-primary-color);
            color: #fff;
            cursor: pointer;
          }
          #resource-lock-wrap .info{
            font-size: 14px;
            line-height: 14px;
            color: #999999;
            margin-top: 25px;
            text-align: left;
          }
          #resource-lock-wrap .info > .mallfont{
            font-size: 16px;
            color: #999;
            margin-right: 6px;
          }
          #resource-lock-wrap .error{
            color: #fe3351;
            height: 15px;
            line-height: 15px;
            font-size: 12px;
            margin-top: 5px;
            text-align: left;
          }
      `}</style>
    </div>
  );
};

export default ResourceLock;
